import api from './index'

export function campaignCreate(data, params = {}) {
  return api.post(`/marketing/campaigns/`, data, { params })
}

export function campaignUpdate(campaignId, data, params = {}) {
  return api.patch(`/marketing/campaigns/${campaignId}/`, data, { params })
}
